module.exports = __webpack_public_path__ + "static/img/7.fb2e2cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/7.png
// module id = Xrua
// module chunks = 0